// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".netto-bidding-summary[data-v-0080af24]{align-items:baseline;color:var(--primary);display:flex;justify-content:space-between}.netto-bidding-summary__text[data-v-0080af24]{font-weight:500}.netto-bidding-summary__value[data-v-0080af24]{font-size:1.5rem;font-weight:700;line-height:1.5;margin-left:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
